import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const ContainerTitulo = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 10%;

  padding: 0 1.6%;
`;
export const TextTitle = styled.p`
  font-size: 26px;
  color: #003644;
  font-weight: bold;
  margin-left: 15px;
`;
export const TextSubTitle = styled.p`
  font-size: 16px;
  color: #003644;
  font-weight: bold;
  margin-left: 15px;
`;
